import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler"
import {networkGroupEdit_template} from "../components/templates/networkGroupEdit_template";

declare var ko: any;
declare var page: any;

export class networkGroup_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected groupEditTemplate: networkGroupEdit_template;

    protected getModuleName(){
        return "networkGroup_edit";
    }

    buildContent() : Array<Element> {
        this.groupEditTemplate = new networkGroupEdit_template("networkGroupEdit_template", this.viewModel, this);
        return [this.groupEditTemplate.build()];
    }
    //
    // fill the page at first load.
    fillPage(): void {
        this.getFormData();
    }

    protected saveEditNetworkGroup(): void {
        this.save();
    }

    protected cancelEditNetworkGroup(){

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Network group action canceled !");

        page.redirect('/network_groups');
    }
    // Getting role data from server.
    public getFormData(): void {

        this.loadingIn(this.groupEditTemplate.builtTemplate.children.namedItem("view-results"));
        let id = this.getVnAppZone().app.params.id;

        if(!isNaN(id) && this.getVnAppZone().app.params.id != 'undefined') {
            this.groupEditTemplate.getTemplateViewModel().idNetworkGroup(id);
        } else {
            id = 0;
        }

        let usrReq_url: string = '/api/network_groups/get/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetNetworkGroupDataReturn;
        this.XHRHdl.execute();
    }

    // Handling response data.
    protected onGetNetworkGroupDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.viewNetworkGroup(response);
                obj.getReferences();
            });
        }
    }

    public viewNetworkGroup(networkGroup: any) : void {
        this.groupEditTemplate.setNetworkGroup(networkGroup);
    }

    private getReferences(): void {

        let usrReq_url: string = '/api/network_groups/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetReferencesDataReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.updateReferences(response);
                obj.loadingOut(obj.groupEditTemplate.builtTemplate.children.namedItem("view-results"));
            });
        }
    }

    protected save(): void {

        let formReq_url: string = '/api/network_groups/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.groupEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostNetworkGroupData;
        XHRHdl.execute();
    }

    private onPostNetworkGroupData(req, obj): Function {
        return function() {

            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Network group saved successfully !");
                page.redirect('/network_groups');

            });
        }
    }

    protected updateReferences(networks: Array<{id: number, name: string, description: string}>): void {

        this.groupEditTemplate.setNetworks(networks);
    }

}



// WEBPACK FOOTER //
// ./js/modules/networkGroup_edit.ts